import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import Legenda from "app/components/itens-orcamento/legenda/Legenda";
import { useMenuSubConsulta } from "app/components/menu-sub-consulta-produto/useMenuSubConsultaProduto";
import globalMU from "globalMU";
import React from "react"

const estiloPedidosFornecedor = require("./pedidosFornecedor.module.scss").default;
const estiloTabela = require('../../../../estilos/tabelas.module.scss').default

export type PedidosFornecedorProps = {
    dadosPedidosFornecedor: PagedMessageResponse<DadosPedidosFornecedor>
}

export type DadosPedidosFornecedor = {
    CodigoFornecedor: number,
    CodigoOutroOrcamento: number,
    DataPedido: string,
    DataPrevisaoRecebimento?: string,
    Nome: string,
    NumeroPedido: number,
    PedidoCompraOrcamento: number,
    QuantidadeNaoEntregue: number,
    UserMessage?: string,
    Transforming: boolean
}


export const PedidosFornecedor = (props: PedidosFornecedorProps) => {

    const componenteQuantidadeNaoEntregue = () => {
        const quantidadeNaoEntregueTotal = () => {
            let total = 0
            props.dadosPedidosFornecedor?.Entities?.forEach((x) => total += x.QuantidadeNaoEntregue)
            return total
        }

        return <div>
            <div className="_text-lg _font-bold _text-blue-500 _mb-4">Totais</div>

            <div className={estiloPedidosFornecedor.dadosQuantidadePerdida}> 
                <label>Quantidade não Entregue</label>
                <div>{globalMU.formatarValorNumerico(quantidadeNaoEntregueTotal(), 3, false)}</div>
            </div>
        </div>
    }

    const tableHead = <div className="_table-row">
        <div className={`_table-cell _font-bold ${estiloPedidosFornecedor.tableCellHeader}`}>
            Fornecedor
        </div>
        <div className={`_table-cell _font-bold ${estiloPedidosFornecedor.tableCellHeader}`}>
            Pedido
        </div>
        <div className={`_table-cell _font-bold ${estiloPedidosFornecedor.tableCellHeader}`}>
            Data do Pedido
        </div>
        <div className={`_table-cell _font-bold _text-right ${estiloPedidosFornecedor.tableCellHeader}`}>
            Quantidade não Entregue
        </div>
        <div className={`_table-cell _font-bold ${estiloPedidosFornecedor.tableCellHeader}`}>
            Previsão de Entrega
        </div>
    </div>

    const tableBody = props.dadosPedidosFornecedor?.Entities?.map((value) => (
        <div key={value.CodigoFornecedor} className="_table-row ">
            <div style={
                value.PedidoCompraOrcamento > 0 && value.QuantidadeNaoEntregue > 0
                    ? { boxShadow: "4px 0 #f00 inset" }
                    : value.PedidoCompraOrcamento > 0 && value.QuantidadeNaoEntregue == 0
                        ? { boxShadow: "4px 0 #fc0 inset" }
                        : value.CodigoOutroOrcamento > 0 && value.PedidoCompraOrcamento > 0 && value.QuantidadeNaoEntregue ?
                            { boxShadow: "4px 0 #0a0 inset" } :
                            { boxShadow: "4px 0 #BEBEBE inset" }
            }
                className={`_table-cell ${estiloPedidosFornecedor.tableCellBody}`}>
                {value.Nome}
            </div>
            <div className={`_table-cell ${estiloPedidosFornecedor.tableCellBody}`}>
                {value.NumeroPedido}
            </div>
            <div className={`_table-cell ${estiloPedidosFornecedor.tableCellBody}`}>
                {globalMU.formatDate(value.DataPedido)}
            </div>
            <div className={`_table-cell _text-right ${estiloPedidosFornecedor.tableCellBody}`}>
                {globalMU.formatarValorNumerico(value.QuantidadeNaoEntregue, 3, false)}
            </div>
            <div className={`_table-cell ${estiloPedidosFornecedor.tableCellBody}`}>
                {globalMU.formatDate(value.DataPrevisaoRecebimento)}
            </div>
        </div>
    ))
    
    return (
        <>
            <div className={estiloTabela.containerRolavel}>
            <div className={`_table _w-full _border-collapse ${estiloPedidosFornecedor.tabelaPedidosFonecedor}`}>
                <div className="_table-header-group ">
                    {tableHead}
                </div>
                <div className="_table-row-group">
                    {tableBody}
                </div>
            </div>
            </div>
            
            <br/> 

            {componenteQuantidadeNaoEntregue()}


            <div>
                <Legenda itens={[
                    {
                        nome: "Não Vinculado a Venda",
                        cor: "#BEBEBE"
                    },
                    {
                        nome: "Vinculado a Venda - Pedido não Entregue",
                        cor: "#f00"
                    },
                    {
                        nome: "Vinculado a Venda - Pedido Entregue",
                        cor: "#fc0"
                    },
                    {
                        nome: "Vinculado a Outra Venda",
                        cor: "#0a0"
                    },
                ]} />
            </div>
            {<section style={{ marginBottom: "100px" }} />}
        </>
    )
}